
const config = {
  "ONLIME_WL": {
    "breakoutDomain": "onlime.open.jotta.cloud",
    "name": "Onlime",
    "alias": "onlime",
    "mainDomain": "cloud.onlime.dk"
  },
  "ELGIGANTEN": {
    "breakoutDomain": "elgiganten.open.jotta.cloud",
    "name": "Elgiganten Cloud",
    "alias": "elgiganten",
    "mainDomain": "cloud.elgiganten.se"
  },
  "MEDIAMARKT": {
    "breakoutDomain": "mediamarkt.open.jotta.cloud",
    "name": "MediaMarkt Cloud",
    "alias": "mediamarkt",
    "mainDomain": "mediamarkt.jotta.cloud"
  },
  "PHONERO": {
    "breakoutDomain": "phonero.open.jotta.cloud",
    "name": "Phonero Sky",
    "alias": "phonero",
    "mainDomain": "sky.phonero.no"
  },
  "HALEBOP": {
    "breakoutDomain": "halebop.open.jotta.cloud",
    "name": "Halebop Cloud",
    "alias": "halebop",
    "mainDomain": "cloud.halebop.se"
  },
  "ELKO": {
    "breakoutDomain": "elko.open.jotta.cloud",
    "name": "ELKO Cloud",
    "alias": "elko",
    "mainDomain": "cloud.elko.is"
  },
  "TELIA_CLOUD": {
    "breakoutDomain": "teliacloud.open.jotta.cloud",
    "name": "Telia Cloud",
    "alias": "teliacloud",
    "mainDomain": "cloud.telia.se"
  },
  "GIGANTTI": {
    "breakoutDomain": "gigantti.open.jotta.cloud",
    "name": "Gigantti Cloud",
    "alias": "gigantti",
    "mainDomain": "cloud.gigantti.fi"
  },
  "LETS_GO": {
    "breakoutDomain": "letsgo.open.jotta.cloud",
    "name": "Let's Go Cloud",
    "alias": "letsgo",
    "mainDomain": "letsgo.jotta.cloud"
  },
  "OBOS": {
    "breakoutDomain": "obos.open.jotta.cloud",
    "name": "Styrerommet",
    "alias": "obos",
    "mainDomain": "arkiv.styrerommet.no"
  },
  "TEST": {
    "breakoutDomain": "test.open.jotta.cloud",
    "name": "TestCloud",
    "alias": "test",
    "mainDomain": "testcloud.jotta.us"
  },
  "SATURN": {
    "breakoutDomain": "saturn.open.jotta.cloud",
    "name": "Saturn Cloud",
    "alias": "saturn",
    "mainDomain": "cloud.saturn.lu"
  },
  "ELKJOP": {
    "breakoutDomain": "elkjop.open.jotta.cloud",
    "name": "Elkjøp Cloud",
    "alias": "elkjop",
    "mainDomain": "cloud.elkjop.no"
  },
  "GET": {
    "breakoutDomain": "teliasky.open.jotta.cloud",
    "name": "Telia Sky",
    "alias": "teliasky",
    "mainDomain": "sky.telia.no"
  },
  "TDC_NO": {
    "breakoutDomain": "tsky.open.jotta.cloud",
    "name": "T-Sky",
    "alias": "tsky",
    "mainDomain": "teliasky.no"
  },
  "COMHEM": {
    "breakoutDomain": "tele2.open.jotta.cloud",
    "name": "Tele2 Cloud",
    "alias": "tele2",
    "mainDomain": "mittcloud.tele2.se"
  },
  "JOTTACLOUD": {
    "breakoutDomain": "jottacloud.open.jotta.cloud",
    "name": "Jottacloud",
    "alias": "jottacloud",
    "mainDomain": "jottacloud.com"
  }
} as const

export default config